export default [

    {
        path: '',
        name: 'usuarios',
        redirect: { name: 'usuarios-preferencias' },
    },

    {
        path: 'alterar-senha',
        name: 'usuarios-alterar-senha',
        component: () => import('@/aplicacao/modulos/usuarios/AlterarSenha'),
        meta: { autenticacao: true },
    },

    {
        path: 'preferencias',
        name: 'usuarios-preferencias',
        component: () => import('@/aplicacao/modulos/usuarios/Preferencias'),
        meta: { autenticacao: true },
    },

    {
        path: 'perfil/:id',
        name: 'usuarios-perfil',
        component: () => import('@/aplicacao/modulos/usuarios/Perfil'),
        meta: { autenticacao: true },
    },

]
